module.exports = __webpack_public_path__ + "img/img3.00cb4635.jpg";